module.exports = __webpack_public_path__ + "static/Ice.f7238b55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ice.jpg
// module id = 460
// module chunks = 35783957827783